export const emailRegex = /^[a-zA-Z0-9._%+'-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;

/** `landscape_16_9` -> `Landscape 16 9`. Leaves the rest of each word's casing alone. */
export const snakeCaseToTitleCase = (value: string) =>
  value.replace(/_/g, ' ').replace(/\b\w/g, (letter) => letter.toUpperCase());

export const truncateStrIfNeeded = (value: string, maxCharacters: number) => {
  if (value.length <= maxCharacters) {
    return { value, isTruncated: false };
  }
  return { value: value.slice(0, maxCharacters), isTruncated: true };
};

/**
 * Safely parse JSON without throwing.
 * @param str - The string to parse
 * @param rejectPrimitives - Whether to reject primitives that can legally be parsed by JSON.parse
 * @returns The parsed JSON, or undefined if the string is not valid JSON or if rejectPrimitives is true and the parsed value is a primitive
 */
export const safeJsonParse = <T>(str: string, rejectPrimitives: boolean = false): T | undefined => {
  try {
    const parsed: unknown = JSON.parse(str);

    if (
      rejectPrimitives &&
      (parsed === null || typeof parsed === 'string' || typeof parsed === 'number' || typeof parsed === 'boolean')
    ) {
      return;
    }

    return parsed as T;
  } catch {
    return;
  }
};
